var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"text-lg w-full cus-button",class:{ active: _vm.isActive },attrs:{"to":_vm.Url},nativeOn:{"click":function($event){return _vm.ActivePage(_vm.Name, _vm.Slug)}}},[_vm._v("\n  "+_vm._s(_vm.Name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }